// extracted by mini-css-extract-plugin
export default {"FeaturesTable":"FeaturesTable-module__FeaturesTable__icHEZm7","FeaturesTable__srOnly":"FeaturesTable-module__FeaturesTable__srOnly__g1sEo4x"};